export interface AnimeItem {
  id: string;
  title: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  rating: number;
  episodes: string;
  status: string;
  description: string;
  views: number;
  updateDate: string;
  tags: string[];
  characters: AnimeCharacter[];
  studio: string;
  year: number;
}

export interface AnimeCharacter {
  name: string;
  role: string;
  imageUrl: string;
  description: string;
}

export interface AnimeCategory {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const animeCategories: AnimeCategory[] = [
  { name: '蜜桃动漫', slug: 'mitao', icon: 'ri-heart-pulse-line', count: 128 },
  { name: '国产精品', slug: 'guochan', icon: 'ri-star-smile-line', count: 96 },
  { name: '美女角色', slug: 'meinv', icon: 'ri-women-line', count: 85 },
  { name: '恋爱甜宠', slug: 'lianai', icon: 'ri-hearts-line', count: 72 },
  { name: '奇幻冒险', slug: 'qihuan', icon: 'ri-magic-line', count: 64 },
  { name: '热血战斗', slug: 'rexue', icon: 'ri-fire-line', count: 58 },
  { name: '搞笑日常', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line', count: 47 },
  { name: '悬疑推理', slug: 'xuanyi', icon: 'ri-search-eye-line', count: 35 },
];

export const animeList: AnimeItem[] = [
  {
    id: 'mitao-1',
    title: '蜜桃成熟时～樱花树下的约定',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20girl%20with%20long%20pink%20hair%20under%20cherry%20blossom%20tree%2C%20soft%20romantic%20atmosphere%2C%20spring%20petals%20falling%2C%20warm%20sunlight%2C%20anime%20art%20style%2C%20delicate%20facial%20features%2C%20pastel%20color%20palette%2C%20dreamy%20bokeh%20background%2C%20high%20quality%20illustration%2C%20elegant%20school%20uniform&width=600&height=800&seq=anime-mitao-1&orientation=portrait',
    category: '蜜桃动漫',
    categorySlug: 'mitao',
    rating: 9.2,
    episodes: '全12话',
    status: '已完结',
    description: '在一个樱花盛开的春天，少女小桃转学到了新的学校。在这里，她邂逅了温柔体贴的学长林风。两人从最初的陌生到渐渐熟悉，樱花树下的每一次相遇都让彼此的心越靠越近。这是一部充满甜蜜与感动的校园恋爱动漫，讲述了青春最美好的模样。',
    views: 1285000,
    updateDate: '2026-07-28',
    tags: ['恋爱', '校园', '青春', '甜蜜', '少女'],
    characters: [
      { name: '苏小桃', role: '女主角', imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20girl%20character%20with%20long%20pink%20hair%20and%20big%20sparkling%20eyes%2C%20wearing%20cute%20school%20uniform%2C%20sweet%20smile%2C%20soft%20pastel%20colors%2C%20anime%20illustration%20style%2C%20clean%20simple%20background%2C%20kawaii%20aesthetic&width=400&height=400&seq=char-mitao-1&orientation=squarish', description: '活泼可爱的转校生，性格温柔善良' },
      { name: '林风', role: '男主角', imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20boy%20character%20with%20dark%20hair%2C%20gentle%20expression%2C%20wearing%20school%20uniform%2C%20handsome%20teenager%2C%20soft%20warm%20lighting%2C%20anime%20art%20style%2C%20clean%20background&width=400&height=400&seq=char-mitao-2&orientation=squarish', description: '成绩优异的学生会长，温柔可靠' },
    ],
    studio: '蜜桃动画工作室',
    year: 2026,
  },
  {
    id: 'mitao-2',
    title: '蜜桃少女的秘密花园',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20girl%20in%20a%20secret%20garden%20full%20of%20peach%20blossoms%2C%20mysterious%20atmosphere%2C%20soft%20light%20filtering%20through%20leaves%2C%20romantic%20fantasy%20setting%2C%20anime%20art%20style%2C%20warm%20pink%20and%20golden%20tones%2C%20delicate%20details&width=600&height=800&seq=anime-mitao-2&orientation=portrait',
    category: '蜜桃动漫',
    categorySlug: 'mitao',
    rating: 9.5,
    episodes: '更新至第8话',
    status: '连载中',
    description: '普通高中生林小桃意外发现了一扇通往神秘花园的门。在那里，她遇见了一群拥有特殊能力的朋友们。这个秘密花园隐藏着关于她身世的重要线索，一场跨越现实与幻想的冒险就此展开。',
    views: 2150000,
    updateDate: '2026-08-02',
    tags: ['奇幻', '冒险', '校园', '魔法', '少女'],
    characters: [
      { name: '林小桃', role: '女主角', imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20girl%20with%20twin%20tails%20and%20magical%20outfit%2C%20holding%20a%20sparkling%20wand%2C%20bright%20determined%20expression%2C%20anime%20illustration%2C%20pink%20and%20white%20color%20scheme%2C%20clean%20background&width=400&height=400&seq=char-mitao2-1&orientation=squarish', description: '拥有打开异世界之门能力的少女' },
      { name: '白夜', role: '男主角', imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20boy%20with%20silver%20hair%20and%20mysterious%20aura%2C%20wearing%20elegant%20fantasy%20clothing%2C%20cool%20expression%2C%20anime%20art%20style%2C%20soft%20blue%20accents%2C%20clean%20background&width=400&height=400&seq=char-mitao2-2&orientation=squarish', description: '来自异世界的守护者，冷静沉着' },
    ],
    studio: '星辰动漫',
    year: 2026,
  },
  {
    id: 'guochan-1',
    title: '斗破苍穹之涅槃重生',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20anime%20martial%20arts%20hero%20with%20flowing%20robes%2C%20standing%20on%20a%20mountain%20peak%2C%20dramatic%20clouds%20and%20golden%20light%2C%20dragon%20spirit%20behind%2C%20donghua%20art%20style%2C%20majestic%20composition%2C%20warm%20golden%20and%20crimson%20tones&width=600&height=800&seq=anime-guoc-1&orientation=portrait',
    category: '国产精品',
    categorySlug: 'guochan',
    rating: 9.7,
    episodes: '全52话',
    status: '已完结',
    description: '天才少年萧炎在经历了人生低谷后，凭借不屈的意志和过人的天赋，一步步重新站上巅峰。本作改编自天蚕土豆同名小说，以精良的制作和扣人心弦的剧情赢得了无数观众的喜爱。',
    views: 5680000,
    updateDate: '2026-06-15',
    tags: ['热血', '玄幻', '战斗', '成长', '国产'],
    characters: [
      { name: '萧炎', role: '男主角', imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20male%20protagonist%20with%20black%20hair%2C%20martial%20arts%20robe%2C%20fierce%20determined%20eyes%2C%20holding%20a%20heavy%20ruler%20weapon%2C%20epic%20anime%20style%2C%20clean%20background&width=400&height=400&seq=char-gc1-1&orientation=squarish', description: '天才炼药师，不屈不挠的修炼者' },
      { name: '萧薰儿', role: '女主角', imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20beautiful%20girl%20with%20long%20silky%20black%20hair%2C%20elegant%20ancient%20dress%2C%20gentle%20but%20strong%20expression%2C%20anime%20art%20style%2C%20ethereal%20beauty%2C%20clean%20background&width=400&height=400&seq=char-gc1-2&orientation=squarish', description: '古族千金，萧炎青梅竹马' },
    ],
    studio: '幻维数码',
    year: 2025,
  },
  {
    id: 'guochan-2',
    title: '仙王的日常生活',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20school%20life%20comedy%2C%20a%20powerful%20immortal%20disguised%20as%20a%20high%20school%20student%2C%20holding%20books%20while%20surrounded%20by%20subtle%20magical%20effects%2C%20donghua%20style%2C%20bright%20and%20colorful%2C%20modern%20school%20setting&width=600&height=800&seq=anime-guoc-2&orientation=portrait',
    category: '国产精品',
    categorySlug: 'guochan',
    rating: 9.3,
    episodes: '更新至第36话',
    status: '连载中',
    description: '修真界最强的仙王王令，为了体验普通人的生活，封印了自己的大部分力量来到人间高中就读。然而，过于强大的实力让他总是无法低调，各种搞笑又刺激的故事就此展开。',
    views: 3890000,
    updateDate: '2026-08-01',
    tags: ['搞笑', '校园', '修仙', '日常', '国产'],
    characters: [
      { name: '王令', role: '男主角', imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20boy%20with%20deadpan%20expression%2C%20wearing%20school%20uniform%2C%20subtle%20glowing%20aura%2C%20Chinese%20donghua%20style%2C%20simple%20and%20clean%2C%20white%20background&width=400&height=400&seq=char-gc2-1&orientation=squarish', description: '最强仙王，表面上是普通高中生' },
      { name: '孙蓉', role: '女主角', imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20girl%20with%20ponytail%2C%20cheerful%20smile%2C%20school%20uniform%2C%20energetic%20pose%2C%20Chinese%20donghua%20style%2C%20bright%20colors%2C%20clean%20background&width=400&height=400&seq=char-gc2-2&orientation=squarish', description: '王令的同桌，活泼开朗的少女' },
    ],
    studio: '绘梦动画',
    year: 2026,
  },
  {
    id: 'meinv-1',
    title: '美少女战士：永恒之月',
    coverImage: 'https://readdy.ai/api/search-image?query=Magical%20girl%20anime%20character%20in%20sailor%20style%20outfit%2C%20transforming%20with%20sparkling%20moonlight%2C%20elegant%20pose%2C%20beautiful%20long%20blonde%20hair%2C%20magical%20ribbons%20and%20stars%2C%20romantic%20fantasy%20atmosphere%2C%20anime%20art%20style%2C%20pastel%20colors&width=600&height=800&seq=anime-meinv-1&orientation=portrait',
    category: '美女角色',
    categorySlug: 'meinv',
    rating: 9.4,
    episodes: '全24话',
    status: '已完结',
    description: '月野兔和她的伙伴们再次面临新的挑战。黑暗势力企图吞噬永恒之月的力量，美少女战士们必须团结一致，用爱与正义的力量守护地球和月球王国。这是一部充满感动与勇气的魔法少女动漫。',
    views: 2450000,
    updateDate: '2026-05-20',
    tags: ['魔法少女', '变身', '友情', '战斗', '经典'],
    characters: [
      { name: '月野兔', role: '女主角', imageUrl: 'https://readdy.ai/api/search-image?query=Magical%20girl%20anime%20heroine%20with%20twin%20buns%20hairstyle%2C%20sailor%20uniform%2C%20holding%20moon%20wand%2C%20kind%20expression%2C%20anime%20style%2C%20sparkling%20effects%2C%20clean%20background&width=400&height=400&seq=char-mv1-1&orientation=squarish', description: '月亮公主的转世，爱哭但勇敢的少女' },
      { name: '地场卫', role: '男主角', imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20handsome%20man%20with%20black%20hair%2C%20wearing%20a%20tuxedo%20and%20mask%2C%20rose%20in%20hand%2C%20mysterious%20expression%2C%20anime%20style%2C%20elegant%2C%20clean%20background&width=400&height=400&seq=char-mv1-2&orientation=squarish', description: '夜礼服假面，月野兔的守护者' },
    ],
    studio: '东映动画',
    year: 2025,
  },
  {
    id: 'meinv-2',
    title: '猫耳少女的奇妙冒险',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20cat%20girl%20with%20fluffy%20ears%20and%20tail%2C%20curious%20expression%2C%20adventure%20gear%2C%20fantasy%20forest%20background%2C%20warm%20sunlight%20through%20trees%2C%20anime%20art%20style%2C%20cute%20and%20whimsical%2C%20soft%20colors&width=600&height=800&seq=anime-meinv-2&orientation=portrait',
    category: '美女角色',
    categorySlug: 'meinv',
    rating: 9.1,
    episodes: '更新至第15话',
    status: '连载中',
    description: '拥有一半猫妖血统的少女铃铛，在一个人类与妖怪共存的世界里展开冒险。她带着爷爷留下的神秘地图，踏上了寻找传说中「万妖之乡」的旅程。一路上她结识了各种有趣的伙伴，也发现了关于自己身世的重大秘密。',
    views: 1680000,
    updateDate: '2026-07-30',
    tags: ['兽娘', '冒险', '奇幻', '治愈', '友情'],
    characters: [
      { name: '铃铛', role: '女主角', imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20nekomimi%20girl%20with%20orange%20cat%20ears%2C%20adventurous%20smile%2C%20wearing%20traveler%20clothes%2C%20anime%20art%20style%2C%20warm%20lighting%2C%20clean%20background&width=400&height=400&seq=char-mv2-1&orientation=squarish', description: '半妖少女，乐观勇敢的冒险家' },
      { name: '小白', role: '伙伴', imageUrl: 'https://readdy.ai/api/search-image?query=Cute%20anime%20white%20fox%20spirit%20companion%2C%20small%20and%20fluffy%2C%20floating%20with%20magical%20glow%2C%20anime%20art%20style%2C%20clean%20background&width=400&height=400&seq=char-mv2-2&orientation=squarish', description: '铃铛的守护灵兽，可变身人形' },
    ],
    studio: '彩色铅笔动画',
    year: 2026,
  },
  {
    id: 'lianai-1',
    title: '恋爱循环～命中注定的你',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20couple%20facing%20each%20other%20under%20starry%20night%20sky%2C%20gentle%20expressions%2C%20hands%20almost%20touching%2C%20soft%20glowing%20fireflies%2C%20anime%20art%20style%2C%20dreamy%20atmosphere%2C%20warm%20pink%20and%20purple%20evening%20sky&width=600&height=800&seq=anime-lian-1&orientation=portrait',
    category: '恋爱甜宠',
    categorySlug: 'lianai',
    rating: 9.6,
    episodes: '全13话',
    status: '已完结',
    description: '内向害羞的高中女生沈若汐，在一次意外中被全校最受欢迎的男生顾言泽所救。两人的命运从此交织在一起，一段青涩又甜蜜的校园恋爱故事就此展开。温柔细腻的情感描写，让人忍不住为之心动。',
    views: 3120000,
    updateDate: '2026-04-10',
    tags: ['恋爱', '校园', '甜宠', '青春', '少女'],
    characters: [
      { name: '沈若汐', role: '女主角', imageUrl: 'https://readdy.ai/api/search-image?query=Shy%20anime%20girl%20with%20glasses%2C%20long%20brown%20hair%2C%20blushing%20expression%2C%20school%20uniform%2C%20anime%20art%20style%2C%20soft%20lighting%2C%20clean%20background&width=400&height=400&seq=char-la1-1&orientation=squarish', description: '内向乖巧的文学少女' },
      { name: '顾言泽', role: '男主角', imageUrl: 'https://readdy.ai/api/search-image?query=Cool%20anime%20boy%20with%20slightly%20wavy%20hair%2C%20gentle%20smile%2C%20school%20uniform%2C%20charismatic%20presence%2C%20anime%20art%20style%2C%20clean%20background&width=400&height=400&seq=char-la1-2&orientation=squarish', description: '全校人气最高的温柔学长' },
    ],
    studio: '蜜桃动画工作室',
    year: 2026,
  },
  {
    id: 'lianai-2',
    title: '霸道少爷爱上我',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20scene%2C%20elegant%20young%20man%20in%20luxurious%20setting%2C%20protective%20pose%2C%20anime%20girl%20looking%20surprised%2C%20mansion%20ballroom%20background%2C%20anime%20art%20style%2C%20warm%20chandelier%20lighting%2C%20dramatic%20romance&width=600&height=800&seq=anime-lian-2&orientation=portrait',
    category: '恋爱甜宠',
    categorySlug: 'lianai',
    rating: 9.0,
    episodes: '更新至第20话',
    status: '连载中',
    description: '普通女大学生苏暖暖在一次兼职中误入了豪门少爷陆景琛的生活。高冷的陆景琛在遇到苏暖暖后，冰山般的心渐渐被融化。两个人从相互嫌弃到彼此依赖，演绎了一段甜蜜又带点狗血的豪门恋爱故事。',
    views: 2780000,
    updateDate: '2026-08-03',
    tags: ['恋爱', '豪门', '甜宠', '都市', '少女'],
    characters: [
      { name: '苏暖暖', role: '女主角', imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20girl%20with%20short%20cute%20hair%2C%20bright%20smile%2C%20casual%20clothes%2C%20cheerful%20and%20optimistic%2C%20anime%20art%20style%2C%20clean%20background&width=400&height=400&seq=char-la2-1&orientation=squarish', description: '乐观开朗的普通女大学生' },
      { name: '陆景琛', role: '男主角', imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20handsome%20man%20in%20elegant%20suit%2C%20cold%20but%20handsome%20expression%2C%20CEO%20vibe%2C%20anime%20art%20style%2C%20clean%20background&width=400&height=400&seq=char-la2-2&orientation=squarish', description: '冷酷霸道的豪门继承人' },
    ],
    studio: '漫影动画',
    year: 2026,
  },
];

export const featuredAnime = animeList.filter((a) => a.rating >= 9.3);

export const latestAnime = [...animeList].sort((a, b) =>
  b.updateDate.localeCompare(a.updateDate)
);

export const popularAnime = [...animeList].sort((a, b) => b.views - a.views);